var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',{attrs:{"size":_vm.size,"src":_vm.avatarurl},on:{"error":_vm.errorHandler}},[_c('i',{staticClass:"el-icon-user-solid",style:({ fontSize: _vm.iconSize + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }